<template>
    <div id="layout">
        <main style="overflow: hidden;">
            <app-content />
        </main>
    </div>
</template>

<script>
    import AppContent from '@/views/site/blocks/AppContent'

    export default {
        name: 'SiteLayout',
        components: {
            AppContent,
        },
    }
    // Layout components
</script>
